import { Button } from '@material-ui/core';

import { useSupportWebChatButtonLang } from './useSupportWebChatButtonLang';

import makeClasses from './SupportWebChatButton.styles';

export const SupportWebChatButton = (props: Props) => {
  const { onClick, showShortText = false } = props;

  const _classes = makeClasses();

  const lang = useSupportWebChatButtonLang({ showShortText });

  return (
    <Button
      fullWidth
      variant='outlined'
      className={_classes.btn}
      onClick={() => onClick()}
    >
      {lang.btnText}
    </Button>
  );
};

export interface Props {
  onClick: (isOM?: boolean) => void;
  showShortText?: boolean;
}
